import { COLORS, fontFamilyFor } from "../../theme";

export const Style = {
  footer: {
    background: "#0f0f0f",
    borderTop: "1px solid rgba(255,255,255,0.05)",
    padding: { xs: "40px 20px 24px", md: "64px 48px 32px" },
  },
  content: {
    maxWidth: "1400px",
    margin: "0 auto 48px",
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "2fr 1fr 1fr 1fr" },
    gap: { xs: "32px", md: "64px" },
  },
  logoContainer: (isArabic) => ({
    display: "flex",
    flexDirection: isArabic ? "row-reverse" : "row",
    alignItems: "center",
    gap: "0.8rem",
    mb: "24px",
  }),
  logoImg: { height: "48px", width: "48px", objectFit: "contain" },
  description: {
    color: "rgba(255,255,255,0.6)",
    lineHeight: 1.7,
    fontSize: "15px",
    maxWidth: "360px",
  },
  sectionHeading: (isArabic) => ({
    fontSize: "16px",
    fontWeight: 700,
    color: COLORS.peach,
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    mb: "20px",
  }),
  linkList: {
    listStyle: "none",
    m: 0,
    p: 0,
    display: "flex",
    flexDirection: "column",
    gap: "13px",
  },
  link: (isArabic) => ({
    color: "rgba(255,255,255,0.6)",
    textDecoration: "none",
    fontSize: "15px",
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    cursor: "pointer",
    transition: "color 0.2s ease",
    "&:hover": { color: COLORS.peach },
  }),
  bottom: {
    maxWidth: "1400px",
    margin: "0 auto",
    paddingTop: "24px",
    borderTop: "1px solid rgba(255,255,255,0.05)",
    textAlign: "center",
    color: "rgba(255,255,255,0.4)",
    fontSize: "14px",
  },
};
